// Alpine
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'

// Polyfill smooth scroll used on several sections for horizontal scrolling
import { elementScrollIntoViewPolyfill } from "seamless-scroll-polyfill";
elementScrollIntoViewPolyfill();

// lazy loading
import yall from 'yall-js';
document.addEventListener("DOMContentLoaded", yall);

// Axios for the request demo form
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// cover hero area on scroll
document.addEventListener('scroll', function () {
    window.requestAnimationFrame( () => {
        let pc = window.scrollY / window.innerHeight;
        document.querySelector('.__hero_cover').style.opacity = pc > 1 ? 1 : pc < 0 ? 0 : pc;
    });
});

// Hero panel animation
import Typed from 'typed.js';

new Typed('.typed', {
    strings: document.querySelector('.__js-heroH1').dataset.typed.split('|'),
    typeSpeed: 100,
    backSpeed: 75,
    backDelay: 1600,
    startDelay: 0,
    smartBackspace: false,
    loop: true,
  });

/* 
 * Alpine objects
 */

// Main
window.app = () => {
    return { 
        modalActive: false, 
        langActive: false, 
        product: 'elite',
        init: function() {
            console.log('here');
            this.$watch('modalActive', active => 
                document.querySelector('html').classList[active ? 'add' : 'remove']('overflow-hidden')
            );
        }
    }
}

// Request a demo modal
const DEMO_ENDPOINT = 'https://delphlyx.io:5000/request_demo';
window.appDemo = () => {
    return {
        submitted: false,
        send: function() {
            axios.post(DEMO_ENDPOINT, new FormData(this.$refs.form))
                .then( () => this.submitted = true )
                .catch( () => alert('Sorry, there was an error - please try again') )
        }
    }
}

// Horizontal sliding sections
window.appSlides = offset => {
    return {
        active: 1,
        slides: [],
        total: null,
        track: null,
        canScroll: null,
        init() {
            this.slides = this.$el.querySelectorAll(':scope .__slide');
            this.total = this.slides.length;
            this.track = this.$el.querySelector(':scope .__track');
            this.reset()
        },
        updateActive(event) {
            this.active = Math.ceil((event.target.scrollLeft - offset) / window.innerWidth ) + 1;
        },
        reset() {
            this.active = 1;
            this.track.scroll({top: 0, left: 0});
            this.canScroll = this.track.scrollWidth - this.track.offsetWidth;
        },
        prev() {
            if( 
                this.track.scrollWidth - this.track.offsetWidth > 0 && 
                this.track.scrollLeft > 0 && 
                this.active > 1 
            ) {
                this.track.scroll({
                    top: 0, 
                    left: this.track.scrollLeft - this.slides[this.active - 2].offsetWidth, 
                    behavior: 'smooth'
                });
                this.active--;
            }
        },
        next() {
            console.log(this.$el,this.total);
            if( 
                this.track.scrollWidth - this.track.offsetWidth > 0 && 
                this.track.scrollLeft < this.track.scrollWidth - this.track.offsetWidth && 
                this.active < this.total 
            ) {
                this.track.scroll({
                    top: 0, 
                    left: this.track.scrollLeft + this.slides[this.active - 1].offsetWidth, 
                    behavior: 'smooth'
                });
                this.active++;
            }
        },
    }
}

Alpine.plugin(intersect);
Alpine.start();